require('./brokerInternalTransferFundsDetails.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const classNames = require('classnames');
const moment = require('moment');

// @components
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
// @helpers
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const { formatAmount, formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
const { toFirstUppercase } = require('utilities/stringHelper');
const IbanHelper = require('utilities/ibanHelper');

// @constants
const { BROKER_REIMBURSE_FUND_TOTAL, EURO_TEXT } = require('constants/index');
const {
    API_ENTERPRISE_NUMBER,
    API_CENTER, FIRST_STEP,
    BROKER_FUNDS_INTERNAL_TRANSFER_CONTRACT_FORMAT,
    BROKER_INTERNAL_TRANSFER_EXISTING_FUND,
    BROKER_PARTIAL_TRANSFER_TYPE_FUNDS_AMOUNT,
    BROKER_PARTIAL_TRANSFER_TYPE_FUNDS_PARTICIPATIONS,
    BROKER_PARTIAL_TRANSFER_TYPE_FUNDS_PERCENTAGE
} = require('constants/index');
const language = getLanguage();

// @utilities
import { recordPage } from "utilities/tagging";

class BrokerInternalTransferFundsDetails extends React.Component {

    componentDidMount() {
        const { immBrokerInternalTransferFunds } = this.props;
        const partialType = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'partialType']);
        const amounts = {
            'percentage': immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'percentage']),
            'participations': immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'participations']),
            'amount': immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'amount']),
        }
        recordPage({
            amount: amounts[partialType],
        });
    }

    buildAccountDetails(fundDetails, immAccounts) {
        const contractNumberValue = fundDetails.getIn(['contrato', 'numerodecontrato'], '');
        const productValue = fundDetails.getIn(['contrato', 'producto'], '');
        const fundControlDigit = fundDetails.get('controlDigit', '');
        const accountProduct = fundDetails.getIn(['cuentaAsociada', 'subgrupo'], '');
        const accountContract = fundDetails.getIn(['cuentaAsociada', 'numerodecontrato'], '');
        const owner = fundDetails.get('nombretitular', '');
        const immAccount = immAccounts.get('byId').find(account =>
            account.get('product') === accountProduct && account.get('contractNumber') === accountContract
        );
        const amountObject = {
            currency: fundDetails.getIn(['saldo2', 'divisa'], 0),
            amount: fundDetails.getIn(['saldo2', 'valorliquidativo'], EURO_TEXT)
        };

        const plainAmountObject = getPlainAmountObject(amountObject);
        let balanceObject = {
            amount: 0,
            currency: EURO_TEXT
        };
        let accountControlDigit;

        if (immAccount) {
            balanceObject = {
                amount: immAccount.getIn(['balances', 'realBalance', 'amount'], 0),
                currency: immAccount.getIn(['balances', 'realBalance', 'currency'], EURO_TEXT)
            };
            accountControlDigit = immAccount.getIn(['ibanComplex', 'digitodecontrol'], '');
        }

        const fundcontract = IbanHelper.formatAccountTextWithSpaces(
            `${API_ENTERPRISE_NUMBER}${API_CENTER}${fundControlDigit}${productValue}${contractNumberValue}`,
            BROKER_FUNDS_INTERNAL_TRANSFER_CONTRACT_FORMAT
        );
        const accountValue = IbanHelper.formatAccountTextWithSpaces(
            `${API_ENTERPRISE_NUMBER}${API_CENTER}${accountControlDigit}${accountProduct}${accountContract}`,
            BROKER_FUNDS_INTERNAL_TRANSFER_CONTRACT_FORMAT
        );
        const plainAmountBalanceObject = getPlainAmountObject(balanceObject);

        return (
            <div className="broker-internal-transfer-funds-details__account-details">
                <div>
                    <FormattedText
                        value="brokerInternalTransferDetails-estimatedValue"
                        className="broker-internal-transfer-funds-details__estimated-value"
                    />
                    <OneLineSymbolAmount
                        amountObject={plainAmountObject}
                        language={language}
                        amountObjectFormatted={formatAmountObject(plainAmountObject, true)}  />
                </div>
                <FormattedText
                    value="brokerInternalTransferDetails-contractNumber"
                    className="broker-internal-transfer-funds-details__contract-number"
                />
                <div className="broker-internal-transfer-funds-details__contract">
                    {fundcontract}
                </div>
                <div className="broker-internal-transfer-funds-details__holder">
                    <span className="broker-internal-transfer-funds-details__label">
                        ({formatText('brokerInternalTransferDetails-holder')}
                    </span>
                    <span>
                        {owner})
                    </span>
                </div>
                <div className="broker-internal-transfer-funds-details__balance">
                    <FormattedText value="brokerInternalTransferDetails-balance" />
                    <OneLineSymbolAmount
                        amountObject={plainAmountBalanceObject}
                        language={language}
                        amountObjectFormatted={formatAmountObject(plainAmountBalanceObject, true)} />
                </div>
                <FormattedText
                    value="brokerInternalTransferDetails-accountNumber"
                    className="broker-internal-transfer-funds-details__account-number"
                />
                <div className="broker-internal-transfer-funds-details__contract">
                    {accountValue}
                </div>
            </div>
        );
    }
    buildContributionInfo() {
        const { immBrokerInternalTransferFunds } = this.props;
        const newContributionAmount = immBrokerInternalTransferFunds.getIn(['steps', 1, 'amount']);
        const newContributionPeriodicity = immBrokerInternalTransferFunds.getIn(['steps', 1, 'periodicityLabel']);
        const newContributionDate = moment(immBrokerInternalTransferFunds.getIn(['steps', 1, 'selectedDate']), 'DD MMM YYYY').format('DD/MM/YYYY');
        const isContributionStepSkipped = immBrokerInternalTransferFunds.get('skipContributionStep');
        const showContributionInfo = newContributionAmount && !isContributionStepSkipped;
        const isContributionSuccess = immBrokerInternalTransferFunds.get('newContributionSuccess');

        if (showContributionInfo) {
          if (isContributionSuccess) {
            return (
              <div className="broker-internal-transfer-funds-details__contrib-info">
                <FormattedText
                  value="brokerInternalTransferDetails-contribInfoAmount"
                  className="broker-internal-transfer-funds-details__contrib-item-title"
                />
                <div className="broker-internal-transfer-funds-details__contrib-item-value">
                  {newContributionAmount}
                </div>
                <FormattedText
                  value="brokerInternalTransferDetails-contribInfoPeriodicity"
                  className="broker-internal-transfer-funds-contrib-item-title"
                />
                <div className="broker-internal-transfer-funds-details__contrib-item-value">
                  {newContributionPeriodicity}
                </div>
                <FormattedText
                  value="brokerInternalTransferDetails-contribInfoDate"
                  className="broker-internal-transfer-funds-contrib-item-title"
                />
                <div className="broker-internal-transfer-funds-details__contrib-item-value">
                  {newContributionDate}
                </div>
              </div>
            );
          }
        }
    }


    buildFundDetails(fund) {
        const { immAccounts, immBrokerInternalTransferFunds } = this.props;
        const fundType = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'fundType']);
        const fundDetails = this.generateFundDetails(fund);
        const contributionInfo = fund === 'destinationFund' ? this.buildContributionInfo() : null;
        let participationsInfo;
        let description;
        let title;
        let accountDetailsBlock;

        if (fund === 'originFund') {
            const participations = this.formatParticipationsAmount(
                fundDetails.get('participaciones')
            );
            const available = this.formatParticipationsAmount(fundDetails.get('disponible'));
            const totalParticipations = `${participations} (${formatText(
                'brokerInternalTransferDetails-available'
            )} ${available})`;

            participationsInfo = (
                <div>
                    <FormattedText
                        value="brokerInternalTransferDetails-participations"
                        className="broker-internal-transfer-funds-details__participations"
                    />
                    <div className="broker-internal-transfer-funds-details__participations-number">
                        {totalParticipations}
                    </div>
                </div>
            );

            title = (
                <FormattedText
                    value="brokerInternalTransferDetails-originFund"
                    className="broker-internal-transfer-funds-details__origin-fund"
                />
            );

            description = fundDetails.get('descripcion', '');
        } else {
            title = (
                <FormattedText
                    value="brokerInternalTransferDetails-destinationFund"
                    className="broker-internal-transfer-funds-details__destination-fund"
                />
            );

            if (fundType === BROKER_INTERNAL_TRANSFER_EXISTING_FUND) {
                description = fundDetails.get('descripcion', '');
            } else {
                description = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'selectedNewFundName']);
            }
        }

        if (fund === 'originFund' || fundType === BROKER_INTERNAL_TRANSFER_EXISTING_FUND) {
            accountDetailsBlock = this.buildAccountDetails(fundDetails, immAccounts);
        }

        return (
            <div className="broker-internal-transfer-funds-details__funds">
                {title}
                <div className="broker-internal-transfer-funds-details__fund-name">
                    {description}
                </div>
                <div className="broker-internal-transfer-funds-details__account-details">
                    {accountDetailsBlock}
                    {contributionInfo}
                </div>
                {participationsInfo}
            </div>
        );
    }

    formatParticipationsAmount(raw) {
        const fraction = `${raw}`.split('.')[1];
        const fractionLength = fraction ? fraction.length : 0;

        return formatAmount(raw, null, fractionLength);
    }

    generateFundDetails(fund) {
        const { immBrokerMyInvestments, immBrokerInternalTransferFunds, immFunds } = this.props;
        const fundId  = immBrokerInternalTransferFunds.getIn(['steps', 0, fund]);
        const funds = immBrokerMyInvestments.getIn(['products','funds','stocks']);
        const selectedFund = funds.find(fund => fund.get('id') === fundId);

        if(selectedFund) {
            const fundDetails = immFunds.find(fund =>
                selectedFund &&
                fund.getIn(['contrato','producto']) === selectedFund.get('product') &&
                fund.getIn(['contrato','numerodecontrato']) === selectedFund.get('numerodecontrato')
            );

            if(fundDetails) {
                return fundDetails.merge({
                    controlDigit: selectedFund.get('controlDigit')
                });
            }
        }
    }
    render() {
        const { immBrokerInternalTransferFunds, isSuccess } = this.props;
        const originFund = this.buildFundDetails('originFund');
        const destinationFund = this.buildFundDetails('destinationFund');
        const isTotal =
            immBrokerInternalTransferFunds.getIn(['steps', 0, 'type']) === BROKER_REIMBURSE_FUND_TOTAL;
        let type;

        if (isTotal) {
            type = formatText('brokerInternalTransferDetails-total');
        } else {
            const partialType = toFirstUppercase(
                immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'partialType'])
            );
            type = formatText(`brokerInternalTransferDetails-partial${partialType}`);
        }

        let contentFunds;
        if (isSuccess) {
            contentFunds = (
                <div className="row">
                    <div className="col-xs-6 broker-internal-transfer-funds-details__left-success">
                        {originFund}
                    </div>
                    <div className="col-xs-6">
                        {destinationFund}
                    </div>
                </div>
            );
        } else {
            contentFunds = (
                <div>
                    {originFund}
                    {destinationFund}
                </div>
            );
        }

        let contentParticipations = '';
        if (!isTotal) {
            const partialType = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'partialType']);
            const value = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, partialType]);
            const currency = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'originFundCurrency']);
            let content;

            switch (partialType) {
                case BROKER_PARTIAL_TRANSFER_TYPE_FUNDS_AMOUNT:
                    const amountObject = {
                        amount: value,
                        currency: currency
                    };
                    const plainAmountObject = getPlainAmountObject(amountObject);

                    content = (
                        <FormattedTextWithComponents
                            value="brokerInternalTransferDetails-partialAmountBalance"
                            injectedComponents={[
                                <OneLineSymbolAmount
                                    key="partialAmountBalance"
                                    amountObject={plainAmountObject}
                                    language={language}
                                    amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
                            ]}
                        />
                    );
                    break;
                case BROKER_PARTIAL_TRANSFER_TYPE_FUNDS_PARTICIPATIONS:
                    const formattedParticipation = this.formatParticipationsAmount(value);
                    content = `${formattedParticipation} ${formatText(
                        'brokerInternalTransferDetails-numberParticipations'
                    )}`;
                    break;
                case BROKER_PARTIAL_TRANSFER_TYPE_FUNDS_PERCENTAGE:
                    const percentage = formatAmount(value);
                    content = (
                        <FormattedText
                            value="brokerInternalTransferDetails-partialPercentageBalance"
                            injectedStrings={[percentage]}
                        />
                    );
                    break;
                default:
                    content = '';
            }

            contentParticipations = (
                <div className="broker-internal-transfer-funds-details__last-div">
                    {content}
                </div>
            );
        }

        const detailsContainerClass = classNames(
            'broker-internal-transfer-funds-details',
            { 'broker-internal-transfer-funds-details__success' : isSuccess }
        );

        return (
            <div className={detailsContainerClass}>
                {contentFunds}
                <FormattedText
                    value="brokerInternalTransferDetails-type"
                    className="broker-internal-transfer-funds-details__type"
                />
                <div className="broker-internal-transfer-funds-details__type-value">
                    {type}
                </div>
                {contentParticipations}
            </div>
        );
    }
}

BrokerInternalTransferFundsDetails.propTypes = {
    immAccounts: PropTypes.object.isRequired,
    immBrokerInternalTransferFunds: PropTypes.object.isRequired,
    immBrokerMyInvestments: PropTypes.object.isRequired,
    immFunds: PropTypes.object.isRequired,
    isSuccess: PropTypes.bool
};

module.exports = BrokerInternalTransferFundsDetails;
